import { MenuItem, Select, TextField } from "@mui/material";
import { Field, FieldArray } from "formik";
import { CustomErrorMessage } from "../../../../components/FormComponents/CustomErrorMessage";
import { hasError } from "../../../../components/FormComponents/utils";
import HorizontalRule from "../../../../components/HorizontalRule/HorizontalRule";
import { IPeca } from "../IObra";
import DeleteIcon from '@mui/icons-material/Delete';
import { SetStateAction, useEffect, useState } from "react";
import { OperacoesForm } from "./OperacoesForm";
import CustomButtonSimple from "../../../../components/CustomMiscellaneous/CustomButtonSimple";
import { Dispatch } from 'react';
import AddIcon from '@mui/icons-material/Add';
import { FileUploader } from "../../../../components/FileUploader";

export function PecasForm({ saveCurrentState, formikProps, pecasArrayHelpers, setPecasAmount, materiais }: { saveCurrentState: any, formikProps: any, pecasArrayHelpers: any, setPecasAmount: Dispatch<SetStateAction<number>>, materiais: any[] }) {

    const { values, errors, touched, handleChange } = formikProps;

    const [selectedPecaIndex, setSelectedPecaIndex] = useState<number | null>(null);

    const addPecas = () => {
        pecasArrayHelpers.push({ reference: '', amount: 0, material: '', desenhosTecnicos: [] });
        saveCurrentState(values);
    }

    const removePeca = (idx: number) => {
        setPecasAmount((pa) => pa - values.pecas[idx].amount);
        pecasArrayHelpers.remove(idx)
    }

    useEffect(()=> {
        const pecasValue = values.pecas.reduce((prev: number, curr: any) => prev + curr.amount, 0);
        setPecasAmount(pecasValue);
    },[values.pecas])


    return (<div className="mt-5">
        <h2 className="font-bold mb-4 mt-3">Peças</h2>
        {values?.pecas && values.pecas.length > 0 ? (values.pecas.map((p: IPeca, idx: number) =>
            <div key={idx} className="border border-red-200 rounded mb-1">
                <div
                    key={idx}
                    className={`flex w-full justify-between items-center border-md p-3`}>
                    <div className="w-4/5 flex justify-between items-center">

                        <Field
                            className={"w-1/2"}
                            name={`pecas.${idx}.reference`}
                            as={TextField}
                            type={"text"}
                            size="small"
                            error={hasError({ errors, touched, name: `pecas.${idx}.reference` as any })}
                            variant={'outlined'}
                            label={'Referência'} />
                        <CustomErrorMessage name={`pecas.${idx}.reference`} />

                        <Field
                            className={"w-1/4"}
                            name={`pecas.${idx}.material`}
                            value={values.pecas[idx].material}
                            as={Select}
                            margin={"dense"}
                            variant={'outlined'}
                            label={'Material'}
                            placeholder={'Material'}
                            renderValue={(item: any) => item.reference}
                        >
                            {materiais.map((c: any) => <MenuItem key={c.id} value={c as any}>{c.reference}</MenuItem>)}
                        </Field>

                        <CustomErrorMessage name={`pecas.${idx}.material`} />


                        <Field
                            className={"w-1/6"}
                            name={`pecas.${idx}.amount`}
                            as={TextField}
                            onChange={(e: any)=>{
                                handleChange(e);
                               
                            }}
                            type={"number"}
                            size="small"
                            error={hasError({ errors, touched, name: `pecas.${idx}.amount` as any })}
                            variant={'outlined'}
                            label={'Quantidade'} />
                        <CustomErrorMessage name={`pecas.${idx}.amount`} />


                    </div>
                    <DeleteIcon className="text-red-400 cursor-pointer mr-5" onClick={() => removePeca(idx)} />


                </div>

                <FieldArray
                    name={`pecas.${idx}.operacoes`}

                    render={arrayHelpers => {
                        return (<div className="ml-2 p-2">
                            <OperacoesForm saveCurrentState={saveCurrentState} setSelectedPecaIndex={setSelectedPecaIndex} selectedPecaIndex={selectedPecaIndex} formikProps={formikProps} operacoesArrayHelper={arrayHelpers} pecaIndex={idx} />

                        </div>)
                    }}
                />

                <Field
                    className={"w-1/6"}
                    name={`pecas.${idx}.desenhosTecnicos`}
                    component={FileUploader}
                    type={"number"}
                    size="small"
                    error={hasError({ errors, touched, name: `pecas.${idx}.desenhosTecnicos` as any })}
                    variant={'outlined'}
                    label={'Desenhos técnicos'} />


            </div>
        )) : null}
        <CustomButtonSimple className="mt-4 h-8" text="Adicionar peça" Icon={AddIcon} onClick={() => addPecas()} />
    </div>)



}